import { createFeatureFlagContext } from "@/utils/featureFlagContextGenerator.utils";

type ModelMenuFeatureFlags = {
  /**
   * Todo remove in LEXUS-7093
   */
  enableEnhancedCarCard: boolean;
  /**
   * End todo remove in LEXUS-7093
   */
};

export const {
  Provider: ModelMenuFeatureFlagsProvider,
  useFeatureFlags: useModelMenuFeatureFlags,
} = createFeatureFlagContext<ModelMenuFeatureFlags>();
